module.exports = __webpack_public_path__ + "img/ob_label.1d5cb247.svg";